var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99962 0.445068H0V7.44468H6.99962V0.445068ZM5.99967 6.44474H0.999945V1.44501H5.99967V6.44474Z",
    fill: "#002E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4981 0.445068H8.49854V7.44468H15.4981V0.445068ZM14.4982 6.44474H9.49848V1.44501H14.4982V6.44474Z",
    fill: "#002E6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0005 7.44468H24.0001V0.445068H17.0005V7.44468ZM18.0004 1.44501H23.0002V6.44474H18.0004V1.44501Z",
    fill: "#002E6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99962 8.9436H0V15.9432H6.99962V8.9436ZM5.99967 14.9433H0.999945V9.94355H5.99967V14.9433Z",
    fill: "#002E6E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49854 15.9432H15.4981V8.9436H8.49854V15.9432ZM9.49848 9.94355H14.4982V14.9433H9.49848V9.94355Z",
    fill: "#002E6E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0005 15.9432H24.0001V8.9436H17.0005V15.9432ZM18.0004 9.94355H23.0002V14.9433H18.0004V9.94355Z",
    fill: "#002E6E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99962 17.4456H0V24.4452H6.99962V17.4456ZM5.99967 23.4452H0.999945V18.4455H5.99967V23.4452Z",
    fill: "#002E6E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49854 24.4452H15.4981V17.4456H8.49854V24.4452ZM9.49848 18.4455H14.4982V23.4452H9.49848V18.4455Z",
    fill: "#002E6E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0005 24.4452H24.0001V17.4456H17.0005V24.4452ZM18.0004 18.4455H23.0002V23.4452H18.0004V18.4455Z",
    fill: "#002E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardView);
export default __webpack_public_path__ + "static/media/card-view.bae1222d2df34cc91d9f969c3369a45f.svg";
export { ForwardRef as ReactComponent };